import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkStartLogin } from '../../redux/actions/gameEntryActions';
import { useAppDispatch } from '../../redux/store';
import { WebGlUnsupportedWarningContainer } from '../../scenes/entry/webGlUnsupportedWarningContainer';
export const WebGlLoginWarningMessageBoxContents = ({ username, password, onClose }) => {
    const socketSend = useSocketSend();
    const dispatch = useAppDispatch();
    const onClickLogin = useCallback(() => {
        onClose();
        dispatch(thunkStartLogin(socketSend, username, password));
    }, [dispatch, onClose, password, socketSend, username]);
    return (_jsxs(_Fragment, { children: [_jsx(DialogContentText, { children: _jsx(WebGlUnsupportedWarningContainer, {}) }), _jsx(DialogActions, { children: _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickLogin, children: "Login Anyway" }) })] }));
};
